import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
export class CompressorDeviceBoxAdapter {
    type = "audio-effect";
    accepts = "audio";
    #context;
    #box;
    #parametric;
    namedParameter; // let typescript infer the type
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = new ParameterAdapterSet(this.#context);
        this.namedParameter = this.#wrapParameters(box);
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get indexField() { return this.#box.index; }
    get labelField() { return this.#box.label; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get host() { return this.#box.host; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#parametric.terminate(); }
    #wrapParameters(box) {
        return {
            lookahead: this.#parametric.createParameter(box.lookahead, ValueMapping.bool, StringMapping.bool, "Lookahead"),
            automakeup: this.#parametric.createParameter(box.automakeup, ValueMapping.bool, StringMapping.bool, "Auto Makeup"),
            autoattack: this.#parametric.createParameter(box.autoattack, ValueMapping.bool, StringMapping.bool, "Auto Attack"),
            autorelease: this.#parametric.createParameter(box.autorelease, ValueMapping.bool, StringMapping.bool, "Auto Release"),
            inputgain: this.#parametric.createParameter(box.inputgain, ValueMapping.linear(-30.0, 30.0), StringMapping.decible, "Input Gain"),
            threshold: this.#parametric.createParameter(box.threshold, ValueMapping.linear(-60.0, 0.0), StringMapping.decible, "Threshold"),
            ratio: this.#parametric.createParameter(box.ratio, ValueMapping.exponential(1.0, 24.0), StringMapping.numeric({ fractionDigits: 1 }), "Ratio"),
            knee: this.#parametric.createParameter(box.knee, ValueMapping.linear(0.0, 24.0), StringMapping.decible, "Knee"),
            attack: this.#parametric.createParameter(box.attack, ValueMapping.linear(0.0, 100.0), StringMapping.numeric({ unit: "ms", fractionDigits: 1 }), "Attack Time"),
            release: this.#parametric.createParameter(box.release, ValueMapping.linear(5.0, 1500.0), StringMapping.numeric({ unit: "ms", fractionDigits: 1 }), "Release Time"),
            makeup: this.#parametric.createParameter(box.makeup, ValueMapping.linear(-40.0, 40.0), StringMapping.decible, "Makeup Gain"),
            mix: this.#parametric.createParameter(box.mix, ValueMapping.unipolar(), StringMapping.percent(), "Dry/Wet")
        };
    }
}
